export const DEFAULT_MEDIA_ELEMENT_ID = 'web-media-player-audio';
